import { FontSize, fontSize } from "constants/fontSize";
import { statusLabelColor } from "constants/newColors";
import React from "react";
import styled, { css } from "styled-components";
import { Status } from "types/status";

export type PresenterProps = {
  status: Status;
  size?: FontSize;
};

export const StatusTextMap = {
  NOT_ASSIGNED: "未アサイン",
  ASSIGNING: "アサイン中",
  DOING: "実施中",
  DONE: "実施済",
  CANCELED: "キャンセル",
  FINISHED: "終了",
  NOT_STARTED: "未実施",
  MONITOR_NOT_ENTERED: "入室待ち",
  MONITOR_ENTERD: "入室済み",
  NOT_STARTED_CANCEL: "開始前キャンセル",
  STARTED_CANCEL: "開始後キャンセル",
  INTERVIEWER_CANCEL: "インタビュアー起因キャンセル",
  MONITOR_CANCEL: "モニター起因キャンセル",
};

const StyledLabel = styled.span<PresenterProps>`
  ${({ status }) => {
    switch (status) {
      case "NOT_ASSIGNED":
        return css`
          color: ${statusLabelColor.NOT_ASSIGNED.text};
          background: ${statusLabelColor.NOT_ASSIGNED.background};
          width: 105px;
        `;
      case "ASSIGNING":
        return css`
          color: ${statusLabelColor.ASSIGNING.text};
          background: ${statusLabelColor.ASSIGNING.background};
          width: 105px;
        `;
      case "DOING":
        return css`
          color: ${statusLabelColor.DOING.text};
          background: ${statusLabelColor.DOING.background};
          width: 105px;
        `;
      case "DONE":
        return css`
          color: ${statusLabelColor.DONE.text};
          background: ${statusLabelColor.DONE.background};
          width: 105px;
        `;
      case "CANCELED":
        return css`
          color: ${statusLabelColor.CANCELED.text};
          background: ${statusLabelColor.CANCELED.background};
          width: 105px;
        `;
      case "FINISHED":
        return css`
          color: ${statusLabelColor.FINISHED.text};
          background: ${statusLabelColor.FINISHED.background};
          width: 105px;
        `;
      case "NOT_STARTED":
        return css`
          color: ${statusLabelColor.NOT_STARTED.text};
          background: ${statusLabelColor.NOT_STARTED.background};
          width: 105px;
        `;
      case "MONITOR_NOT_ENTERED":
        return css`
          color: ${statusLabelColor.MONITOR_NOT_ENTERED.text};
          background: ${statusLabelColor.MONITOR_NOT_ENTERED.background};
          width: 105px;
        `;
      case "MONITOR_ENTERD":
        return css`
          color: ${statusLabelColor.MONITOR_ENTERD.text};
          background: ${statusLabelColor.MONITOR_ENTERD.background};
          width: 105px;
        `;
      case "NOT_STARTED_CANCEL":
        return css`
          color: ${statusLabelColor.NOT_STARTED_CANCEL.text};
          background: ${statusLabelColor.NOT_STARTED_CANCEL.background};
          width: 235px;
        `;
      case "STARTED_CANCEL":
        return css`
          color: ${statusLabelColor.STARTED_CANCEL.text};
          background: ${statusLabelColor.STARTED_CANCEL.background};
          width: 235px;
        `;
      case "INTERVIEWER_CANCEL":
        return css`
          color: ${statusLabelColor.INTERVIEWER_CANCEL.text};
          background: ${statusLabelColor.INTERVIEWER_CANCEL.background};
          width: 235px;
        `;
      case "MONITOR_CANCEL":
        return css`
          color: ${statusLabelColor.MONITOR_CANCEL.text};
          background: ${statusLabelColor.MONITOR_CANCEL.background};
          width: 235px;
        `;
    }
  }};

  font-size: ${({ size }) => {
    return size ? fontSize[size] : fontSize.small;
  }};

  display: inline-block;
  font-weight: bold;
  text-align: center;
  letter-spacing: 0.1em;
  /* TODO: paddingなどspace系もグローバル変数化したい */
  padding-block: 0.35em;
  border-radius: 1000px;
  box-sizing: border-box;
`;

export const StatusLabelPresenter: React.FC<PresenterProps> = ({
  status,
  size,
}) => {
  return (
    <StyledLabel status={status} size={size}>
      {StatusTextMap[status]}
    </StyledLabel>
  );
};
